import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import React from 'react'
import PropTypes from 'prop-types'
import styles from 'components/Modal/modal.module.scss'
import { Button, Icon } from 'gu-ui-kit'

export const CloseButton = ({
  color = 'Label-Secondary',
  colorHover = 'Interface-Seventh',
  colorActive = 'Interface-Eleven',
  bgColor = 'none',
  bgColorHover = 'none',
  bgColorActive = 'none',
  className,
  ...rest
}) => {
  const { t } = useTranslation(['common'])

  return (
    <Button
      noLabel
      startIcon={<Icon name={'close'} />}
      size={'m'}
      title={t('close_button')}
      color={color}
      colorHover={colorHover}
      colorActive={colorActive}
      bgColor={bgColor}
      bgColorHover={bgColorHover}
      bgColorActive={bgColorActive}
      className={clsx(className, styles['close-button'])}
      {...rest}
    />
  )
}
CloseButton.propTypes = {
  color: PropTypes.string,
  colorHover: PropTypes.string,
  colorActive: PropTypes.string,
  bgColor: PropTypes.string,
  bgColorHover: PropTypes.string,
  bgColorActive: PropTypes.string,
  className: PropTypes.string,
}
